'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../aviary-core/dist/cjs/index.cjs');

/**
 * SVG Illustration of wholesale
 */ const Wholesale = ({ assetColor = index.ASSET_COLORS.grey, size = index.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 105",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M104 52.4863C104 81.2051 80.7188 104.486 52 104.486C23.2812 104.486 0 81.2051 0 52.4863C0 23.7675 23.2812 0.486328 52 0.486328C80.7188 0.486328 104 23.7675 104 52.4863Z",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "12.3164",
                y: "39.2305",
                width: "79.3526",
                height: "6.61272",
                rx: "2.22011",
                fill: theme.ds5.asset[assetColor]["400"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "12.3164",
                y: "71.4004",
                width: "79.3526",
                height: "6.31214",
                rx: "2.22011",
                fill: theme.ds5.asset[assetColor]["400"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M52.7497 58.212V56.6913H53.2288C53.5689 56.6913 53.8446 56.4156 53.8446 56.0755V54.4285C53.8446 54.0884 53.5689 53.8127 53.2288 53.8127H44.4272C44.0871 53.8127 43.8114 54.0884 43.8114 54.4285V56.0755C43.8114 56.4156 44.0871 56.6913 44.4272 56.6913H44.9062V58.2344C44.3054 58.4538 43.7874 58.8485 43.4215 59.3655C43.0557 59.8824 42.8595 60.4969 42.8594 61.1266V71.4794C42.8594 71.8195 43.1351 72.0952 43.4752 72.0952H54.2469C54.587 72.0952 54.8627 71.8195 54.8627 71.4794V61.128C54.8627 60.4865 54.6592 59.8609 54.2805 59.3383C53.9018 58.8157 53.3668 58.422 52.7497 58.212Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "43.7227",
                y: "53.8225",
                width: "10.1321",
                height: "2.88202",
                rx: "0.423997",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M39.613 58.212V56.6913H40.092C40.4321 56.6913 40.7078 56.4156 40.7078 56.0755V54.4285C40.7078 54.0884 40.4321 53.8127 40.092 53.8127H31.2904C30.9504 53.8127 30.6747 54.0884 30.6747 54.4285V56.0755C30.6747 56.4156 30.9504 56.6913 31.2904 56.6913H31.7695V58.2344C31.1687 58.4538 30.6507 58.8485 30.2848 59.3655C29.9189 59.8824 29.7228 60.4969 29.7227 61.1266V71.4794C29.7227 71.8195 29.9984 72.0952 30.3384 72.0952H41.1102C41.4503 72.0952 41.726 71.8195 41.726 71.4794V61.128C41.726 60.4865 41.5225 59.8609 41.1438 59.3383C40.7651 58.8157 40.23 58.422 39.613 58.212Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "30.582",
                y: "53.8225",
                width: "10.1321",
                height: "2.88202",
                rx: "0.423997",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M75.3083 58.212V56.6913H75.7874C76.1274 56.6913 76.4031 56.4156 76.4031 56.0755V54.4285C76.4031 54.0884 76.1274 53.8127 75.7874 53.8127H66.9858C66.6457 53.8127 66.37 54.0884 66.37 54.4285V56.0755C66.37 56.4156 66.6457 56.6913 66.9858 56.6913H67.4648V58.2344C66.864 58.4538 66.346 58.8485 65.9801 59.3655C65.6142 59.8824 65.4181 60.4969 65.418 61.1266V71.4794C65.418 71.8195 65.6937 72.0952 66.0338 72.0952H76.8055C77.1456 72.0952 77.4213 71.8195 77.4213 71.4794V61.128C77.4213 60.4865 77.2178 59.8609 76.8391 59.3383C76.4604 58.8157 75.9254 58.422 75.3083 58.212Z",
                fill: theme.ds5.asset[assetColor]["400"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "66.2773",
                y: "53.8225",
                width: "10.1321",
                height: "2.88202",
                rx: "0.423997",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M78.5306 63.3468V62.2629H78.9462C79.1477 62.2629 79.311 62.0996 79.311 61.8981V60.5757C79.311 60.3742 79.1477 60.2109 78.9462 60.2109H72.5238C72.3224 60.2109 72.1591 60.3742 72.1591 60.5757V61.8981C72.1591 62.0996 72.3224 62.2629 72.5238 62.2629H72.9395V63.3628C72.5113 63.5192 72.142 63.8005 71.8812 64.1691C71.6204 64.5376 71.4806 64.9756 71.4805 65.4244V72.8784C71.4805 73.0798 71.6438 73.2431 71.8452 73.2431H79.672C79.8735 73.2431 80.0368 73.0798 80.0368 72.8784V65.4254C80.0367 64.9681 79.8917 64.5222 79.6217 64.1497C79.3518 63.7772 78.9704 63.4965 78.5306 63.3468Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "72.0898",
                y: "60.2051",
                width: "7.22241",
                height: "2.05437",
                rx: "0.251135",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M46.406 25.3423V23.8217H46.885C47.2251 23.8217 47.5008 23.546 47.5008 23.2059V21.5589C47.5008 21.2188 47.2251 20.9431 46.885 20.9431H38.0834C37.7433 20.9431 37.4676 21.2188 37.4676 21.5589V23.2059C37.4676 23.546 37.7433 23.8217 38.0834 23.8217H38.5624V25.3648C37.9617 25.5842 37.4436 25.9789 37.0778 26.4958C36.7119 27.0128 36.5157 27.6273 36.5156 28.2569V38.6098C36.5156 38.9498 36.7913 39.2255 37.1314 39.2255H47.9032C48.2433 39.2255 48.519 38.9498 48.519 38.6098V28.2583C48.519 27.6168 48.3154 26.9913 47.9368 26.4687C47.5581 25.9461 47.023 25.5524 46.406 25.3423Z",
                fill: theme.ds5.asset[assetColor]["400"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "37.3438",
                y: "20.937",
                width: "10.1321",
                height: "2.88202",
                rx: "0.423997",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M38.7181 30.2081V29.1242H39.1337C39.3352 29.1242 39.4985 28.9609 39.4985 28.7595V27.437C39.4985 27.2356 39.3352 27.0723 39.1337 27.0723H32.7113C32.5099 27.0723 32.3466 27.2356 32.3466 27.437V28.7595C32.3466 28.9609 32.5099 29.1242 32.7113 29.1242H33.127V30.2241C32.6988 30.3805 32.3295 30.6619 32.0687 31.0304C31.8079 31.3989 31.6681 31.8369 31.668 32.2857V39.7397C31.668 39.9411 31.8313 40.1044 32.0327 40.1044H39.8595C40.061 40.1044 40.2243 39.9411 40.2243 39.7397V32.2867C40.2242 31.8295 40.0792 31.3836 39.8092 31.011C39.5393 30.6385 39.1579 30.3579 38.7181 30.2081Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "32.2773",
                y: "27.0645",
                width: "7.22241",
                height: "2.05437",
                rx: "0.251135",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M65.5159 28.3345V27.0462H66.0099C66.2494 27.0462 66.4434 26.8521 66.4434 26.6127V25.0409C66.4434 24.8015 66.2494 24.6074 66.0099 24.6074H58.3768C58.1373 24.6074 57.9433 24.8015 57.9433 25.0409V26.6127C57.9433 26.8521 58.1373 27.0462 58.3768 27.0462H58.8708V28.3535C58.3618 28.5394 57.9229 28.8737 57.613 29.3117C57.303 29.7497 57.1368 30.2703 57.1367 30.8037V39.6629C57.1367 39.9023 57.3308 40.0964 57.5702 40.0964H66.8725C67.112 40.0964 67.306 39.9023 67.306 39.6629V30.8049C67.306 30.2614 67.1336 29.7315 66.8128 29.2887C66.4919 28.846 66.0386 28.5124 65.5159 28.3345Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "57.8555",
                y: "24.6172",
                width: "8.58398",
                height: "2.44166",
                rx: "0.298478",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M76.4143 28.3345V27.0462H76.9084C77.1478 27.0462 77.3419 26.8521 77.3419 26.6127V25.0409C77.3419 24.8015 77.1478 24.6074 76.9084 24.6074H69.2752C69.0358 24.6074 68.8417 24.8015 68.8417 25.0409V26.6127C68.8417 26.8521 69.0358 27.0462 69.2752 27.0462H69.7692V28.3535C69.2603 28.5394 68.8214 28.8737 68.5114 29.3117C68.2014 29.7497 68.0353 30.2703 68.0352 30.8037V39.6629C68.0352 39.9023 68.2292 40.0964 68.4686 40.0964H77.771C78.0104 40.0964 78.2045 39.9023 78.2045 39.6629V30.8049C78.2045 30.2614 78.032 29.7315 77.7112 29.2887C77.3904 28.846 76.9371 28.5124 76.4143 28.3345Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "68.7656",
                y: "24.6172",
                width: "8.58398",
                height: "2.44166",
                rx: "0.298478",
                fill: theme.ds5.asset[assetColor]["500"]
            })
        ]
    });
};

exports.Wholesale = Wholesale;
//# sourceMappingURL=Wholesale.cjs.map
